import styled from 'styled-components';

const StCommunityContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 50px auto;
  width: 1440px;
`;

const Sttitle = styled.strong`
  font-weight: 700;
  font-size: 20px;
`;

const StboardListContainer = styled.div`
  display: flex;
  gap: 30px;
`;

export { StCommunityContainer, Sttitle, StboardListContainer };
